import styled from "styled-components";


export const MintNum = styled.textarea`

    width: 100px;
    height: 40px;
    padding: 10px;
    outline: none;
    font-size: 35px;
    text-align: center;
    
    border-radius: 5px;
    resize: none;
    transition: 0.5s;
    &:focus{
        transform: scale(1.2);
        transition: 0.5s;
    }

`

export const TextWrapper = styled.div`
    max-width: 540px;
    display: flex;
    margin: 0 auto;
    padding-top: 0;
    padding-bottom: 0px;
    justify-content: center;
    text-align: center;
`

export const Subtitle = styled.p`
    max-width: 440px;
    
    font-size: 20px;
    line-height: 35px;
    color: ${({darkText}) => (darkText ? '#010606' : "#fff")};
`

export const MintContainer = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
`